import config from '../utils/config'
import request from '../utils/request'

const { api } = config
const {
    eventForm, event, events, eventConfig, eventHeader,eventSimples,
    uniqueField, shareConfig, eventImages, eventWxLevelShare,eventSimple,
    eventWxLevelShareExp, eventWxLevelShareStatis, eventGroups, eventGroupShare,
    eventComments,eventFeedbacks } = api





/**
 * 报名表单
 */
export async function findEventCiForm(params) {
    return request({ url: eventForm, method: 'get', data: params, })
}


export async function findUniqueField(params) {
    return request({ url: uniqueField, method: 'get', data: params, })
}

/**
 * 查找活动
 */
export async function findEvent(params) {
    return request({ url: event, method: 'get', data: params, })
}

export async function findEventSomple(params) {
    return request({ url: eventSimple, method: 'get', data: params, })
}
export async function createEventSomples(params) {
    return request({ url: eventSimples, method: 'post', data: params, })
}



/**
 * 查找活动,会增加浏览数
 */
export async function findEventWithViewedCounted(params) {
    return request({ url: event, method: 'get', data: Object.assign(params, { viewedCounted: true }), })
}



/**
 * 查询基本信息
 */
export async function findEventHeader(params) {
    return request({ url: eventHeader, method: 'get', data: params, })
}



/**
 * 更新活动配置信息
 */
export async function findEventConfig(params) {
    return request({ url: eventConfig, method: 'get', data: params, })
}
/**
 * 投诉
 */
export async function updateEventFeedbacks(params) {
    return request({ url: eventFeedbacks, method: 'post', data: params, })
}









/**
 * 查找活动列表
 */
export async function findEvents(params) {
    return request({ url: events, method: 'get', data: params, })
}

/**
 * 查询分享
 */
export async function findShareConfig(params) {
    return request({ url: shareConfig, method: 'get', data: params, })
}

/**
 * 查询邀请函图片
 */
export async function findEventImages(params) {
    return request({ url: eventImages, method: 'get', data: params, })
}


/**
 * 微信分享营销
 */
export async function findEventWxLevelShare(params) {
    return request({ url: eventWxLevelShare, method: 'get', data: params, })
}
export async function expEventWxLevelShare(params) {
    return request({ url: eventWxLevelShareExp, method: 'get', data: params, })
}
export async function findEventWxLevelShareStatis(params) {
    return request({ url: eventWxLevelShareStatis, method: 'get', data: params, })
}


/**
 * 活动分组
 */
export async function findEventGroups(params) {
    return request({ url: eventGroups, method: 'get', data: params, })
}

export async function findEventGroupShare(params) {
    return request({ url: eventGroupShare, method: 'get', data: params, })
}


/**
 * 评论
 */
export async function findEventComments(params) {
    return request({ url: eventComments, method: 'get', data: params, })
}
export async function createEventComments(params) {
    return request({ url: eventComments, method: 'post', data: params, })
}







// WEBPACK FOOTER //
// ./src/services/evt.js